var module = angular.module('common.directives.general', []);
/**
 * https://stackoverflow.com/questions/28114970/angularjs-ng-options-using-number-for-model-does-not-select-initial-value
 */
module.directive('convertToNumber', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function (val) {
                return val !== null ? parseInt(val, 10) : null;
            });
            ngModel.$formatters.push(function (val) {
                return val !== null ? '' + val : null;
            });
        }
    };
});

/**
 * page title directly from template (page-title="Title")
 *
 * simplified and in our needs extended this: https://github.com/apparentlymart/angularjs-viewhead/blob/master/angularjs-viewhead.js
 */
var title;
module.directive('pageTitle', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
        return {
            restrict: 'EA',
            link: function (scope, iElement, iAttrs, controller, transcludeFn) {
                // If we've been inserted as an element then we detach from the DOM because the caller
                // doesn't want us to have any visual impact in the document.
                // Otherwise, we're piggy-backing on an existing element so we'll just leave it alone.
                var tagName = iElement[0].tagName.toLowerCase();
                if (tagName === 'page-title' || tagName === 'pagetitle') {
                    iElement.remove();
                }


                scope.$watch(
                    function () {
                        // page-title="title" or <span page-title>title</span>
                        var titleText = iAttrs.pageTitle ? iAttrs.pageTitle : iElement.text();
                        return titleText;
                    },
                    function (newTitle) {
                        $rootScope.pageTitle = title = newTitle;
                    }
                );
                scope.$on(
                    '$destroy',
                    function () {
                        title = undefined;
                        // Wait until next digest cycle do delete viewTitle
                        $timeout(function () {
                            if (!title) {
                                // No other view-title has reassigned title.
                                delete $rootScope.viewTitle;
                            }
                        });
                    }
                );
            }
        };
    }]
);
